var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9662 17.7471H6.18848V20.9995H17.9662V17.7471Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6275 9.66602H16.4388V11.785H7.71638V9.66602H3.52765C2.68991 9.66602 2 10.2574 2 11.0458V21.0002H5.20315V16.8608H18.952V21.0002H22.1552V11.0458C22.1552 10.2574 21.4653 9.66602 20.6275 9.66602ZM5.74522 12.7213H4.31612V10.8487H5.74522V12.7213Z",
    fill: "#272727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1286 6.16768C17.0793 6.06912 17.03 6.01985 16.9808 5.92129L15.1081 4.04868C14.9603 3.90084 14.7632 3.85156 14.6154 3.85156H7.71628C7.51916 3.85156 7.32204 3.95012 7.22348 4.04868C7.07565 4.19652 7.02637 4.39363 7.02637 4.54147V11.7362H7.76555V9.61722V4.54147H14.1226H14.6154L14.8125 4.83715L16.1923 6.21696L16.3894 6.41408V6.90687V9.61722V11.7362H17.1286V6.41408C17.1779 6.31552 17.1286 6.21696 17.1286 6.16768Z",
    fill: "#272727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1779 6.56192C17.1779 6.75903 17.03 6.95615 16.7836 6.95615H14.8125C14.6153 6.95615 14.4182 6.90687 14.3197 6.75903C14.1718 6.6112 14.1226 6.46336 14.1226 6.26624V4.2458C14.1226 4.04868 14.2704 3.85156 14.5168 3.85156C14.6153 3.85156 14.8125 3.9994 14.8125 4.2458V6.26624H16.1923H16.7836C16.9807 6.21696 17.1779 6.3648 17.1779 6.56192Z",
    fill: "#272727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 8.5332H8.94824V9.27239H14.8125V8.5332Z",
    fill: "white",
    stroke: "#272727",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71624 11.7842H6.97705",
    stroke: "#272727",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1782 11.7842H16.439",
    stroke: "#272727",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 8.5332H8.94824V9.27239H14.8125V8.5332Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.f9fa054647d3468e68f475ce21dc75ec.svg";
export { ForwardRef as ReactComponent };